import EmptyableCardViewHealth from '../../../../components/Card/EmptyableCardViewHealth';
import ViewAllPostedJobsCardHealth from '../../../../components/Card/ViewAllPostedJobsCardHealth';

const DummyPostedJobs = [
  {
    imgSrc: '/static/img/applicantholder.png',
    title: 'Pharmacist',
    description:
      'A pharmacist is needed at OOUTH, sagamu for an overnight shift',
  },
  {
    imgSrc: '/static/img/applicantholder.png',
    title: 'Pharmacist',
    description:
      'A pharmacist is needed at OOUTH, sagamu for an overnight shift',
  },
  {
    imgSrc: '/static/img/applicantholder.png',
    title: 'Pharmacist',
    description:
      'A pharmacist is needed at OOUTH, sagamu for an overnight shift',
  },
  {
    imgSrc: '/static/img/applicantholder.png',
    title: 'Pharmacist',
    description:
      'A pharmacist is needed at OOUTH, sagamu for an overnight shift',
  },
];

const ViewAllPostedJobs = () => {
  return (
    <EmptyableCardViewHealth
      label="Recent Applications"
      emptyViewNote="You current don’t have any job application
click here to list one"
      isEmpty={false}
    >
      {DummyPostedJobs.map((data, index) => (
        <ViewAllPostedJobsCardHealth
          key={index}
          imgSrc={data.imgSrc}
          title={data.title}
          description={data.description}
        />
      ))}
    </EmptyableCardViewHealth>
  );
};

export default ViewAllPostedJobs;
